import SectionTitle from '../common/SectionTitle';
import hospitalimg from '../../Assets/TeamandOthers/Aboutimg4.webp'
const AboutSection = () => (
  <section className="py-20 bg-gray-50">
    <div className="container mx-auto px-6">

      {/* Section Header */}
      <div className="text-center mb-14">
        <span className="inline-block bg-white text-blue-600 px-6 py-2 rounded-full font-medium text-xl shadow-sm mb-4">
          About Us
        </span>

        <SectionTitle title="Dr. Sridhar International Dental Hospitals & Research Center" />

        <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
          Trusted dental care in Hyderabad, delivering excellence through
          innovation, experience, and compassionate patient care.
        </p>
      </div>

      {/* Content */}
      <div className="grid md:grid-cols-2 gap-12 items-center">
        
        {/* Image */}
       {/* Image */}
<div className="relative flex justify-center">
  <img
    src={hospitalimg}
    alt="Sridhar Dental International Clinic Hyderabad"
    className="rounded-2xl shadow-2xl w-full max-w-md md:max-w-lg object-cover"
  />

  {/* Experience Badge */}
  <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-blue-600 text-white px-16 py-6 rounded-xl shadow-lg">
    <p className="text-5xl font-bold">30+</p>
    <p className="text-sm uppercase tracking-wide">Years Experience</p>
  </div>
</div>


        {/* Text */}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Creating Healthy Smiles Since 1995
          </h3>

          <p className="text-gray-600 leading-relaxed mb-6">
            Headquartered in Hyderabad, Dr. Sridhar International Dental Hospitals & Research Center was
            established in 1995 with a commitment to providing world-class dental
            care. Over the last 30+ years, we have evolved into a premium dental
            healthcare destination by integrating state-of-the-art facilities,
            digital dentistry, and advanced treatment techniques.
          </p>

          <p className="text-gray-600 leading-relaxed mb-8">
            Our comprehensive dental and oral care services have helped thousands
            of patients restore their smiles, confidence, and overall oral health
            through ethical practices and personalized care.
          </p>

          <a
            href="/about"
            className="inline-flex items-center bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition shadow-md"
          >
            Read More
            <span className="ml-2 text-lg">→</span>
          </a>
        </div>

      </div>
    </div>
  </section>
);

export default AboutSection;
